import { z } from "zod/v4";

import { ConfigurationResponseDtoSchema } from "../../../dtos/configurations";
import { JsonSchema } from "../../../utils";

const ConfigurationSchema = z.object({
  key: z.string(),
  value: JsonSchema,
  locked: z.boolean().nullish(),
});

export const EditConfigurationsRequestBodySchema = ConfigurationSchema.array();

export type EditConfigurationsRequestBodyType = z.infer<
  typeof EditConfigurationsRequestBodySchema
>;

export const EditConfigurationsResponseBodySchema = z.object({
  configurations: ConfigurationResponseDtoSchema.array(),
});

export type EditConfigurationsResponseBodyType = z.infer<
  typeof EditConfigurationsResponseBodySchema
>;
